import { ensureShepherdModalOverlayHidden } from './shepherd-interactive-step';

export const TRAINING_FILTERS_STEP_ID = 'training-list-filters';

export const TRAINING_FILTERS_INTERACTION_CLASS = 'shepherd-training-filters-interaction';

/** Results / empty / book steps: full-page dim outside blue highlight (filters step uses interaction class). */
export const TRAINING_TOUR_SPOTLIGHT_CLASS = 'shepherd-training-tour-spotlight';

/** Material datepicker calendar is portaled to `body` — keep it above Shepherd while open. */
export const TRAINING_FILTERS_DATEPICKER_OPEN_CLASS = 'shepherd-training-filters-datepicker-open';

export function setTrainingFiltersInteractionActive(active: boolean): void {
  document.body.classList.toggle(TRAINING_FILTERS_INTERACTION_CLASS, active);
}

export function setTrainingTourSpotlightActive(active: boolean): void {
  document.body.classList.toggle(TRAINING_TOUR_SPOTLIGHT_CLASS, active);
}

export function clearTrainingTourUi(): void {
  setTrainingFiltersInteractionActive(false);
  setTrainingFiltersDatepickerOpen(false);
  setTrainingTourSpotlightActive(false);
  resetTrainingFiltersTargetPadding();
  ensureShepherdModalOverlayHidden();
}

export function setTrainingFiltersDatepickerOpen(active: boolean): void {
  document.body.classList.toggle(TRAINING_FILTERS_DATEPICKER_OPEN_CLASS, active);
}

export function resolveTrainingFiltersTarget(): HTMLElement | null {
  return document.querySelector('.filters-section');
}

export function resetTrainingFiltersTargetPadding(): void {
  const root = resolveTrainingFiltersTarget();
  if (root) {
    root.style.paddingBottom = '';
  }
}
